import { render, staticRenderFns } from "./VulnerabilityItem.vue?vue&type=template&id=1de25bcf&scoped=true&"
import script from "./VulnerabilityItem.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityItem.vue?vue&type=script&lang=js&"
import style0 from "./VulnerabilityItem.vue?vue&type=style&index=0&id=1de25bcf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de25bcf",
  null
  
)

export default component.exports